<ng-container>
    <ng-container *ngTemplateOutlet="
    content;
  ">
    </ng-container>
</ng-container>
<ng-template #content>
    <p class="ibk-description text-center">
        Ingresa tu RUC Y DNI
    </p>
    <div class="ba-field-group" formGroupName="dataCollection">
        <ibk-input-group class="span-2">
            <label class="ibk-description">
                N&uacute;mero de RUC personal o de empresa
            </label>
            <ibk-input class="field" char-filter="^[0-9]{1,8}$">
                <input placeholder="Ingrese N&uacute;mero de RUC personalo de empresa" class="field" type="text"
                    name="ruc" formControlName="ruc" maxlength="11" (blur)='blurNumberRuc()' />
            </ibk-input>
        </ibk-input-group>
    </div>
    <p class="error-message" *ngIf="form.get('dataCollection.ruc')?.errors">Ingresa un RUC v&aacute;lido</p>
    <div class="toast" *ngIf="doubleLegalRepresentative && showAskLegalRepresentative">
        <img class="toast-icon" [src]="asset('assets/images/info_red.svg')" alt="Info icon">
        <div class="toast-message"> Si tu empresa tiene 2 representantes legales con firmas conjuntas, ambos deben
            ir a la tienda para abrir su Cuenta Negocios. </div>
    </div>
    <div class="ba-field-group" formGroupName="dataCollection" *ngIf="showAskLegalRepresentative">
        <ibk-input-radio-group dsRxForm="radioChange" #taxControl="control" formControlName="representative"
            name="representative" class="radio-group" (change)="changeLegalRepresentative($event)">
            <label class="text-bold">
                ¿Eres el &uacute;nico representante legal de tu empresa?
            </label>
            <br />
            <br />
            <ibk-input>
                <span>S&iacute;</span>
                <input [value]="'true'" />
            </ibk-input>
            <ibk-input>
                <span>No, somos m&aacute;s de un representante legal</span>
                <input [value]="'false'" />
            </ibk-input>
        </ibk-input-radio-group>
    </div>
    <div class="ba-field-group" formGroupName="dataCollection">
        <ibk-input-radio-group dsRxForm="radioChange" #taxControl="control" formControlName="taxResidence"
            name="taxResidence" class="radio-group" (change)="changeTaxResidence($event)">
            <label class="text-bold">
                ¿Tu empresa tiene residencia fiscal o tributaria en el Per&uacute;?
            </label>
            <br />
            <br />
            <ibk-input>
                <span>S&iacute;</span>
                <input [value]="'true'" />
            </ibk-input>
            <ibk-input>
                <span>No</span>
                <input [value]="'false'" />
            </ibk-input>
        </ibk-input-radio-group>
    </div>
    <ibk-toast type="INFO" *ngIf="showTaxResidence">
        Al marcar "Si" declaro bajo juramento que la información proporcionada es veraz, completa y actualizada, de
        conformidad con la Ley 26702 (Ley General del Sistema Financiero) y el Decreto Supremo 256-2018-EF (Información
        financiera que los bancos deben comunicar a SUNAT).
    </ibk-toast>
    <ibk-toast type="ERROR" *ngIf="notTaxResidence">
        Lo sentimos, la creaci&oacute;n de esta cuenta requiere que tu empresa posea residencia y obligaciones fiscales
        y tributarias solo en Per&uacute;.
    </ibk-toast>
    <br *ngIf="notTaxResidence" />
    <br *ngIf="notTaxResidence" />
    <!-- <ibk-button class="ba-action" [loading]="isLoading">
        <button id="validation-code-otp-step" class="ibk-btn ibk-btn--min-width ibk-btn--primary ba-btn">
            Verificar
        </button>
    </ibk-button> -->
    <div class="ba-field-group" formGroupName="dataCollection">
        <ibk-input-group class="span-2">
            <label>Tipo de documento (*)</label>
            <ng-container>
                <ibk-select dsRxForm="selectChange" class="field" formControlName="documentType" name="documentType">
                    <ibk-select-option [value]="DocumentType.DNI"></ibk-select-option>
                </ibk-select>
            </ng-container>
        </ibk-input-group>
    </div>
    <div class="ba-field-group" formGroupName="dataCollection">
        <ibk-input-group class="span-2">
            <label class="ibk-description">
                N° de documento (*)
            </label>
            <ibk-input class="field" char-filter="^[0-9]{1,8}$">
                <input placeholder="Ingrese N&uacute;mero de documento" class="field" type="text" name="documentNumber"
                    maxlength="8" formControlName="documentNumber" />
            </ibk-input>
        </ibk-input-group>
    </div>
    <hr class="ibk-separator" />
    <br />
    <br />
    <section class="checkbox-group" formGroupName="dataCollection">
        <ibk-input id="authorize-personal-data">
            <input type="checkbox" formControlName="privacyPolicy" />
            <b class="b-title"> He le&iacute;do y acepto las condiciones de la <a href="#" class="ibk-link-privacy">
                    Pol&iacute;tica de Privacidad. </a> </b>
        </ibk-input>
        <ibk-input id="authorize-personal-data">
            <input type="checkbox" />
            <b class="b-title"> Autorizo el uso de mis datos personales para finalidades opcionales previstas en la
                Pol&iacute;tica de Privacidad (opcional). </b>
        </ibk-input>
        <ibk-input id="authorize-personal-data">
            <input type="checkbox" formControlName="identityByBiometrics" />
            <b class="b-title"> Acepto validar mi identidad como representante legal mediante biometr&iacute;a y OTP
            </b>
        </ibk-input>
    </section>
    <div class="ba-field-group-view">
        <label class="ibk-description link-opacity">
            La informaci&oacute;n brindada por el cliente tiene calidad declaraci&oacute;n Jurada.
        </label>
    </div>
    <div class="ba-field-group-view">
        <label class="ibk-description link-opacity">
            Este sitio est&aacute; protegido por reCAPTCHA. Aplican la <a href="#" class="ibk-link" (click)="''">
                Pol&iacute;tica de Privacidad </a> de Google y los <a href="#" class="ibk-link" (click)="''">
                T&eacute;rminos
                del Servicio. </a>
        </label>
    </div>
    <ibk-button class="ba-action" [loading]="isLoading">
        <button id="valid-data-collection" class="ibk-btn ibk-btn--min-width ibk-btn--primary ba-btn"
            [disabled]="dataCollectionForm.invalid" (click)="onGoStartupDone()">
            Comencemos
        </button>
    </ibk-button>
    <p class="text-center ibk-description text-bold">
        Conoce los beneficios de tu Cuenta Negocio
    </p>

    <div class="ba-field-group">
        <a href="#" class="ibk-link text-center" (click)="evtCollapseView($event)">{{titleSeeMore}}</a>
    </div>
    <div class="collapse-div">
        <div class="ba-field-group-view content-div">
            <img class="img-see-more-less" [src]="asset('assets/images/bank-access.svg')" alt="bank access">
            <label class="ibk-description text-primary title-size-large">
                Acceso a la banca por Internet de Empresas GRATIS
            </label>
            <p class="ibk-description">
                Realizar las operaciones que necesitas sin salir de tu negocio desde tu Banca por Internet Empresas o
                APP
                Interbank Empresas.
            </p>
        </div>
        <div class="ba-field-group-view content-div">
            <img class="img-see-more-less" [src]="asset('assets/images/exchange-rate.svg')" alt="exchange-rate">
            <label class="ibk-description text-primary title-size-large">
                Tipo de cambio preferencial
            </label>
            <p class="ibk-description">
                Podr&aacute;s abrir al mismo tiempo tu cuenta en soles y d&oacute;lares y acceder&aacute;s a un tipo de
                cambio preferencial.
            </p>
        </div>
        <div class="ba-field-group-view content-div">
            <img class="img-see-more-less" [src]="asset('assets/images/best-plan.svg')" alt="best-plan">
            <label class="ibk-description text-primary title-size-large">
                El mejor plan para tu negocio
            </label>
            <p class="ibk-description">
                No cobra mantenimiento para Persona Jur&iacute;dicas si realizas una transacci&oacute;n por cualquiera
                de nuestros
                canales.
            </p>
        </div>
        <div class="ba-field-group-view content-div">
            <img class="img-see-more-less" [src]="asset('assets/images/free-deposit.svg')" alt="free-deposit">
            <label class="ibk-description text-primary title-size-large">
                Haz tus dep&oacute;sitos sin costo *
            </label>
            <p class="ibk-description">
                Podr&aacute;s hacer dep&oacute;sitos ilimitados en cajeros Global Net y Agentes sin costo.
            </p>
        </div>
        <div class="ba-field-group-view content-div">
            <img class="img-see-more-less" [src]="asset('assets/images/debit-card.svg')" alt="debit-card">
            <label class="ibk-description text-primary title-size-large">
                Tarjeta de d&eacute;bito y/o chequera para tu empresa
            </label>
            <p class="ibk-description">
                Podr&aacute;s abrir al mismo tiempo tu cuenta en soles y d&oacute;lares y acceder&aacute;s a un tipo de
                cambio preferencial.
            </p>
        </div>
        <hr class="ibk-separator" />
<!--        <div class="ba-field-group-view">-->
<!--            <label class="ibk-description title-questions">-->
<!--                Preguntas frecuentes-->
<!--            </label>-->
<!--        </div>-->
<!--        <div class="ba-field-group-view">-->
<!--            <button class="ibk-btn collapsible">-->
<!--                <span class="text title-size-large">¿Qu&eacute; hacer si ya apertur&eacute; mi Cuenta Negocios?</span>-->
<!--            </button>-->
<!--            <div class="ibk-description content">-->
<!--                <p class="title-size-large">Texto pendiente</p>-->
<!--            </div>-->
<!--            <hr class="ibk-separator" />-->
<!--            <button class="ibk-btn collapsible">-->
<!--                <span class="text title-size-large">¿Cómo ingresar a mi BPI por primera vez?</span>-->
<!--            </button>-->
<!--            <div class="ibk-description content">-->
<!--                <p class="title-size-large">Texto pendiente</p>-->
<!--            </div>-->
<!--            <hr class="ibk-separator" />-->
<!--            <button class="ibk-btn collapsible">-->
<!--                <span class="text title-size-large">¿Qué hacer si mi clave temporal ya expiró?</span>-->
<!--            </button>-->
<!--            <div class="ibk-description content">-->
<!--                <p class="title-size-large">Texto pendiente</p>-->
<!--            </div>-->
<!--            <hr class="ibk-separator" />-->
<!--            <button class="ibk-btn collapsible">-->
<!--                <span class="text title-size-large">¿Qué hacer si no me han llegado mis accesos?</span>-->
<!--            </button>-->
<!--            <div class="ibk-description content">-->
<!--                <p class="title-size-large">Texto pendiente</p>-->
<!--            </div>-->
<!--        </div>-->
        <p class="title-size-large">TREA mínima en soles de 1.4% a 365 días. Monto mínimo 2,000. Interés
            acumulado S/28.39. Válido al
            28/02/18. ITF 0.005%. Fondo de Seguro de Depósito (FSD) Diciembre 2017-Febrero 2018: S/97,529.00. El
            monto de cobertura del FSD actualizado, tasas de interés, comisiones, gastos y penalidades en el
            tarifario, en TiendasInterbank o en <span class="text-primary">www.interbank.pe,</span> conforme a
            la normativa vigente.</p>
    </div>
</ng-template>
